import type { ParticipantBehaviour } from '@piccolohealth/pbs-common';
import { ChakraV3, Spin } from '@piccolohealth/ui';
import React from 'react';
import { PiccoloError } from '../../../components/generic/PiccoloError';
import { useParticipantBehavioursRecordingsQuery } from '../../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../../hooks/useAppContext';
import { ParticipantBehaviourRecordingCreateButton } from '../../behaviours/components/ParticipantBehaviourRecordingCreateButton';
import { ParticipantBehaviourRecordingsTable } from '../../behaviours/components/ParticipantBehaviourRecordingsTable';

interface Props {
  participantId: string;
  tabButtons: React.ReactNode;
  isDisabled?: boolean;
}

export const ParticipantDataTablesTab = (props: Props) => {
  const { participantId, tabButtons, isDisabled } = props;

  const { organization } = useAppContext();

  const { isLoading, error, data } = useParticipantBehavioursRecordingsQuery({
    organizationId: organization.id,
    participantId,
  });

  const participantBehaviours =
    (data?.organization?.participant?.behaviours as ParticipantBehaviour[]) ?? [];

  if (isLoading) {
    return <Spin />;
  }

  if (error) {
    return <PiccoloError error={error} />;
  }

  return (
    <ChakraV3.Stack w='full' h='full' gap={4} overflowY='hidden'>
      <ChakraV3.HStack w='full' px={6} pt={4}>
        {tabButtons}
        <ChakraV3.Stack w='full' pb={1}>
          <ChakraV3.Stack h='34px' />
        </ChakraV3.Stack>
        <ChakraV3.Spacer />
        <ChakraV3.HStack flexShrink={1}>
          <ParticipantBehaviourRecordingCreateButton
            participantId={participantId}
            participantBehaviours={participantBehaviours}
            colorPalette='brand'
            disabled={isDisabled}
          >
            Add recording
          </ParticipantBehaviourRecordingCreateButton>
        </ChakraV3.HStack>
      </ChakraV3.HStack>
      <ParticipantBehaviourRecordingsTable
        participantId={participantId}
        participantBehaviours={participantBehaviours}
      />
    </ChakraV3.Stack>
  );
};
